import React, { Component } from "react";
import "./App.css";
import * as Moment from "moment";
import { HashRouter as Router, Route, Redirect } from "react-router-dom";

import Activities from "./components/activities/activities";
import Members from "./components/members/members";
import MemberProfile from "./components/memberProfile/memberProfile";
import MemberProfileEdit from "./components/memberProfileEdit/memberProfileEdit";
import { FIREBASE_CONFIG } from "./config";
import firebase from "firebase/app";
import "firebase/firestore";

import Login from "./components/login/login";
import Ranking from "./components/ranking/ranking";
import Stat from "./components/stat/stat";

import { iMemberProfile } from "./components/UI/MemberProfileInterface";
import NewMember from "./components/NewMember/NewMember";
import Tak from "./components/NewMember/Tak";
import styled, { css } from "styled-components";
import * as _ from "lodash";

import NewUser from "./components/newUser/newUser";

const AppWrap = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 20px;
  height: 100vh;

  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  position: relative;

  ${(props) =>
    props.printMode
      ? css`
          max-width: none;
          margin: 20px;

          @media print {
            margin-top: 1.5 cm;
            margin-bottom: 1cm;
            margin-left: 1.5cm;
            margin-right: 0.5cm;
          }
        `
      : css`
          margin: 0 auto;
          box-shadow: 1px 1px 40px 0px #777;
          max-width: 800px;
        `}
`;

Moment.updateLocale("en", {
  relativeTime: {
    future: "om %s",
    past: "%s siden",
    s: "få sek",
    ss: "%d sekr",
    m: "ét minut",
    mm: "%d min",
    h: "en time",
    hh: "%d timer",
    d: "en dag",
    dd: "%d dage",
    M: "en mnd",
    MM: "%d mnd",
    y: "et år",
    yy: "%d år",
  },
  months: [
    "Januar",
    "Februar",
    "Marts",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "December",
  ],
});

class App extends Component {
  messaging;

  constructor(props) {
    super(props);
    firebase.initializeApp(FIREBASE_CONFIG);

    this.state = {
      activityTypes: [],
      compatible: true,
      matchParams: {},
      searchValue: "",
      teamId: "",
      status: "",
      members: [],
      teams: null,
      levels: [],
      ranks: [],
      pageData: null,
      filteredMembers: [],
      foundNewMembersCount: 0,
      firebaseNotInitialized: false,
      firebaseReady: false,
      membersLoaded: false,
      loadingMmembers: false,
      printMode: false,

      currentlyLoggedInUser: null,
      isAuthenticated: false,
      authenticatedUser: firebase.auth(),
      userAuthorized: firebase.auth().currentUser ? true : false, // localStorage.getItem("authorized") == "true" ? true : false
    };
  }

  componentDidMount() {
    // Listen to the Firebase Auth state and set the local state.
    this.unregisterAuthObserver = firebase.auth().onAuthStateChanged((user) => {
      console.log("onAuthStateChanged >> user: ", user);
      this.setState({
        isAuthenticated: !!user,
        currentlyLoggedInUser: { ...user },
      });
      console.log("USER IS:", user);
    });

    console.log("FIREBASE -->> START INITIALIZE...");
    firebase
      .firestore()
      .enablePersistence({ synchronizeTabs: true })
      .then(() => {
        console.log("FIREBASE -->> INITIALIZE SUCCESS");

        this.db = firebase.firestore();
        // console.log(this.db.settings);
        // const firestore = firebase.firestore();
        const settings = { timestampsInSnapshots: true };
        // this.db.settings(settings);

        // if (this.isAuthenticated) {
        this.loadUidData();
        // } else {
        // window.history.pushState(null, null, "/login");
        // window.location.reload();
        // }
      })
      .catch(function (err) {
        console.log("FIREBASE NOT INITIALIZED");
        console.log("error:", err);
        this.setState({ firebaseNotInitialized: true });

        if (err.code == "failed-precondition") {
          // Multiple tabs open, persistence can only be enabled
          // in one tab at a a time.
          // ...
        } else if (err.code == "unimplemented") {
          // The current browser does not support all of the
          // features required to enable persistence
          // ...
        }
      });
  }

  // Make sure we un-register Firebase observers when the component unmounts.
  componentWillUnmount() {
    this.unregisterAuthObserver();
  }

  setAuthenticatedUser(user) {
    console.log("setting authenticated USER:", user);
    // console.log("STATE=", this.state);
    this.setState({
      authenticatedUser: { ...user },
      currentlyLoggedInUser: { ...user },
    });

    // console.log("STATE after=", this.state);
  }

  setPrintMode = (mode) => {
    this.setState({ printMode: mode });
  };

  loadUidData() {
    const uid = firebase.auth().currentUser && firebase.auth().currentUser.uid;
    // console.log(
    //   "loadUidData >>  firebase.auth().currentUser: ",
    //   firebase.auth().currentUser
    // );
    // console.log("loadUidData >>  firebase.auth(): ", firebase.auth());
    // console.log("loadUidData >> ", uid);
    // if (!firebase.auth().currentUser) {
    //   // user is not authenticated -- logout and go to start
    //   // window.history.pushState(null, null, "#/logout");
    //   // window.history.go();

    //   // firebase
    //   // .auth()
    //   // .signOut()
    //   // .then(r => {
    //   //   console.log("sign off success!");
    //   //   console.log(this.props);
    //     window.history.pushState(null, null, "/login");
    //     window.location.reload();
    //   // });

    //   this.setState({isAuthenticated: false})

    //   return false;
    // }

    // console.log(
    //   "loadUidData >> UID: ",
    //   firebase.auth().currentUser && firebase.auth().currentUser.uid
    // );

    if (uid) {
      this.db
        .collection("uid")
        .doc(uid)
        .get()
        .then((querySnapshot) => {
          var data = querySnapshot.data();

          const currentlyLoggedInUser = {
            ...this.state.currentlyLoggedInUser,
            uidProfile: { ...data },
          };

          console.log("CURRENTLY LOGGED IN USER:", currentlyLoggedInUser);

          this.setState({
            firebaseReady: true,
            currentlyLoggedInUser: { ...currentlyLoggedInUser },
          });
        })
        .catch((e) => {
          console.log("loadUidData >> error on loading from db: ", e);
        });
    } else {
      // this.setState({ firebaseNotInitialized: true });

      console.log("UID: ", uid);
      console.log("state :", this.state);
      this.setState({
        firebaseReady: true,
      });
    }
  }

  loadTeamsData() {
    this.db
      .collection("teams")
      .get()
      .then((querySnapshotTeams) => {
        var teams = [];
        querySnapshotTeams.forEach(function (doc) {
          teams.push(doc.data());
        });

        this.setState({ teams: { ...teams } });
      });
  }

  loadActivityTypes = () => {
    // get activityTypes
    this.db
      .collection("activityTypes")
      .get()
      .then((querySnapshot) => {
        var data = [];
        querySnapshot.forEach(function (doc) {
          data.push({ ...doc.data(), ID: doc.id });
        });

        this.setState({ activityTypes: [...data] });
      });
  };

  // ********************************************************************
  //
  // PREPARE REALTIME MEMBER DATA
  //
  // ********************************************************************
  PrepareMemberData() {}
  // ********************************************************************
  //
  // LOAD MEMBER DATA
  //
  // ********************************************************************
  async loadMemberData() {
    if (this.state.loadingMembers || this.state.membersLoaded) return false; // members are being loaded
    console.log("--------------loadMemberData REALTIME UPDATER INIT !!!");

    this.setState({ loadingMembers: true });

    // console.log("loadzMemberData  BEFORE PROMISE!!!");
    // const membersPromise = this.db.collection("members").get();
    const teamsPromise = this.db.collection("teams").get();
    const levelsPromise = this.db.collection("levels").get();
    const ranksPromise = this.db.collection("ranks").get();

    const [_teams, _levels, _ranks] = await Promise.all([
      // membersPromise,
      teamsPromise,
      levelsPromise,
      ranksPromise,
    ]);

    // ------------------------------------------------------------------------------------

    let teams = [];
    _teams.forEach((doc) => teams.push(doc.data()));

    // ------------------------------------------------------------------------------------

    let levels = [];
    _levels.forEach((doc) => levels.push(doc.data()));

    // ------------------------------------------------------------------------------------

    var ranks = [];
    _ranks.forEach((doc) => ranks.push(doc.data()));

    const composedRanks = ranks.map((rank) => {
      return { ...rank, level: levels.find((l) => l.ID == rank.LevelId) };
    });

    const sortedRanks = composedRanks.sort((a, b) =>
      Moment(a.RankDate).isAfter(b.RankDate) ? -1 : 1
    );

    // db listen
    await this.db.collection("members").onSnapshot(async (snapshot) => {
      console.log("*** loadMemberData ** >> Member updated!");
      let members = [];
      // snapshot.docChanges().forEach(function(change) {
      //   if (change.type === "added") {
      //     console.log("New MEMBER: ", change.doc.data());
      //   }
      //   if (change.type === "modified") {
      //     console.log("Modified MEMBER: ", change.doc.data());
      //   }
      //   if (change.type === "removed") {
      //     console.log("Removed MEMBER: ", change.doc.data());
      //   }
      // });

      snapshot.forEach((doc) => members.push(doc.data()));

      // ------------------------------------------------------------------------------------

      // console.log("levels :", levels);
      // console.log("sortedRanks :", sortedRanks);
      // console.log("membersWithTeams :", membersWithTeams);
      // console.log("teams :", teams);
      // console.log("teams :", teams);

      // Sort members by name
      const sortedMembers = members.sort((a, b) =>
        a.FirstName < b.FirstName ? -1 : 1
      );

      let foundNewMembersCount = 0;
      const membersWithTeams = sortedMembers.map((member) => {
        // see if there are new members.
        if (
          (member.Status && member.Status.toLowerCase() == "ny") ||
          (member.Status && member.Status.toLowerCase() == "klar")
        ) {
          foundNewMembersCount++;
        }

        member.TeamName = teams.find((t) => member.TeamId == t.ID)
          ? teams.find((t) => member.TeamId == t.ID).TeamName
          : null;

        return member;
      });

      this.setState({
        levels: [...levels],
        ranks: [...sortedRanks],
        members: [...membersWithTeams],
        teams: { ...teams },
        foundNewMembersCount,
        membersLoaded: true,
        loadingMembers: false,
      });

      this.loadActivityTypes();

      // Uses whatever values are in the state
      this.updateFilteredMembers(null, null, null, true);
    });
  }

  // *************************************************************************
  //  updateFilteredMembers
  // -------------------------------------------------------------------------
  //
  //
  // *************************************************************************
  updateFilteredMembers(searchValue, teamId, status, useState) {
    console.log(
      "searchValue:",
      searchValue,
      ", TeamId=",
      teamId,
      ", Status=",
      status
    );
    if (searchValue === undefined) {
      searchValue = "";
    }

    if (useState) {
      console.log(
        "updateFilteredMembers >>> USE STATE | searchValue:",
        this.state.searchValue,
        ", TeamId=",
        this.state.teamId,
        ", Status=",
        this.state.status
      );

      console.log("PROPS MATCH: ", this.state);

      searchValue = this.state.searchValue ? this.state.searchValue : "";
      teamId = this.state.teamId ? this.state.teamId : "";
      status = this.state.status ? this.state.status : "";
      // searchValue = this.state.searchValue ? this.state.searchValue : this.props.match.params.searchValue;
      // teamId = this.state.teamId ? this.state.teamId: this.props.match.params.teamId;
      // status = this.state.status ? this.state.status: this.props.match.params.status;
    } else {
      this.setState({ searchValue, teamId, status });
    }

    // Only continue if members has been loaded
    if (!this.state.membersLoaded) return false;

    let foundMembers = [];
    if (!searchValue) {
      foundMembers = this.state.members;
    } else {
      let searchString = searchValue.toString().toLowerCase();
      foundMembers = this.state.members.filter((member) => {
        const foundFirstName = member.FirstName
          ? member.FirstName.toString().toLowerCase().indexOf(searchString) > -1
            ? true
            : false
          : true;
        const foundLastName = member.LastName
          ? member.LastName.toString().toLowerCase().indexOf(searchString) > -1
            ? true
            : false
          : true;

        return foundFirstName || foundLastName;
      });
    }

    // Filter teams
    // if teamId = -1 then take all
    // it teamId = -100 then take all active
    // console.log("foundMembers before : ", foundMembers);
    foundMembers = foundMembers.filter((member) => {
      if (
        member.TeamId == teamId ||
        teamId == "-1" ||
        (member.TeamId != "99" && teamId == "-100")
      ) {
        return true;
      }
      return false;
    });

    // console.log("foundMembers: ", foundMembers);

    // Filter status if status contains data
    if (status && status !== "any") {
      foundMembers = foundMembers.filter((member) => {
        // console.log("member ", member.Status && member.Status.indexOf(status) != -1 ? true : false)

        if (status.toLowerCase() == "ny") {
          return (member.Status &&
            member.Status.toLowerCase().indexOf("ny") != -1) ||
            (member.Status && member.Status.toLowerCase().indexOf("klar") != -1)
            ? true
            : false;
        } else {
          return member.Status && member.Status.indexOf(status) != -1
            ? true
            : false;
        }
      });
    }

    this.setState({
      filteredMembers: foundMembers,
      searchValue,
      teamId,
      status,
    });
  }

  // *****************************************************************
  //
  // deleteMember
  //
  // *****************************************************************
  deleteMember = (memberId) => {
    this.db
      .collection("members")
      .doc(memberId)
      .delete()
      .then((res) => {
        console.log("Member deleted");

        // remove member from members list
        const withoutDeletedMember = this.state.members.filter(
          (x) => x.ID !== memberId
        );

        let foundNewMembersCount = 0;
        this.state.members.map((member) => {
          // see if there are new members.
          if (
            (member.Status && member.Status.toLowerCase() == "ny") ||
            (member.Status && member.Status.toLowerCase() == "klar")
          ) {
            foundNewMembersCount++;
          }
        });

        this.setState({ members: withoutDeletedMember, foundNewMembersCount });
        this.updateFilteredMembers(null, null, null, true);
      });
  };

  /****************************************************
   *
   * UPDATE MEMBER
   *
   ***************************************************/
  updateMember = (memberId, member, fromForm) => {
    console.log("updateMember >> member: ", member);
    let memberAllreadyUdmeldt = false;

    // find member in members array
    let foundMember = this.state.members.find((m) => m.ID == memberId);
    // console.log("foundMember: ", foundMember);

    if (!foundMember) {
      return false;
    }

    if (fromForm) {
      // find team ID and teamName
      for (let key in member) {
        if (key == "TeamName") {
          // If the current member id is 99 then allready 'udmeldt'.
          memberAllreadyUdmeldt = foundMember.TeamId == "99";

          // Set new member TeamId
          foundMember.TeamId = member[key].value;

          // console.log("foundMember.TeamId = ", foundMember.TeamId);


          for (let key in this.state.teams) {
            if (this.state.teams[key].ID == foundMember.TeamId) {
              foundMember.TeamName = this.state.teams[key].TeamName;
            }
          }
        } else {
          foundMember[key] =
            member[key] && member[key].value ? member[key].value : null;
          // console.log(
          //   "key: ",
          //   key,
          //   ", value:",
          //   member[key] && member[key].value && member[key].value
          // );
        }
      }
    } else {
      // use member data as is.
      foundMember = { ...member };
    }

    // console.log("before save, state:", this.state)
    // save update
    this.db
      .collection("members")
      .doc(memberId)
      .set(foundMember)
      .then((result) => {

        console.log("foundMember: ", foundMember)
        console.log("member: ", member)
        console.log("memberAllreadyUdmeldt: ", memberAllreadyUdmeldt)

        if (foundMember.TeamId == "99" && !memberAllreadyUdmeldt) {
          // Udmeldt
          // Send email to user and admin
          const headers = {
            "Content-Type": "application/json",
          };

          const AZURE_URL_BYE =
            "https://prod-57.northeurope.logic.azure.com:443/workflows/860aa9b433d44b76b95cf69931143efe/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=wK2Kyr_VqCuB4uA1Biy8v16zvHulTlxphAj8jZ86eME";
       
          fetch(AZURE_URL_BYE, {
            method: "POST",
            mode: "cors",
            headers: headers,
            body: JSON.stringify(foundMember),
          }).then((r) => {
            // window.location.href = "/#/thanks";
            // window.history.pushState(null, null, "/#/thanks");


            // window.location.reload();
            // window.history.go();
          });
        }
      });

    console.log("updateMember >> state:", this.state);
    const updatedMembers = this.state.members.map((m) => {
      if (m.ID == memberId) m = { ...foundMember };
      return m;
    });

    // console.log(teams);
    let foundNewMembersCount = 0;
    this.state.members.map((member) => {
      // see if there are new members.
      if (
        (member.Status && member.Status.toLowerCase() == "ny") ||
        (member.Status && member.Status.toLowerCase() == "klar")
      ) {
        foundNewMembersCount++;
      }
    });

    this.setState({ members: updatedMembers, foundNewMembersCount });
    // this.updateFilteredMembers(null, null, null, true);
  };

  userLogin = (e) => {
    e.preventDefault();
    localStorage.setItem("authorized", "true");
  };

  addRankToSelectedMembers = (
    selectedMembers,
    selectedLevel,
    selectedRankingDate
  ) => {
    let currentRanks = [...this.state.ranks];

    const newRanks = selectedMembers.map((m) => {
      let rank = {
        LevelId: selectedLevel.ID,
        MemberId: m.key,
        RankDate: selectedRankingDate,
        level: selectedLevel,
      };

      // Add a new document with a generated id.
      this.db
        .collection("ranks")
        .add({})
        .then((docRef) => {
          //console.log("new rank placeholder added with ID: ", docRef.id);
          rank.ID = docRef.id;

          this.db
            .collection("ranks")
            .doc(docRef.id)
            .set(rank)
            .then((result) => {
              // console.log("Rank added for ", rank.MemberId);
            })
            .catch(function (error) {
              // console.error("Error adding document: ", error);
            });
        })
        .catch(function (error) {
          console.error("Error adding document: ", error);
        });

      // save the new rank to the db

      return rank;
    });

    // -----------------------------
    const composedRanks = [...currentRanks, ...newRanks];
    const sortedRanks = composedRanks.sort((a, b) => {
      return Moment(a.RankDate).isAfter(b.RankDate) ? -1 : 1;
    });

    // console.log("Sorted Ranks: ", sortedRanks);
    this.setState({ ranks: [...sortedRanks] });
  };

  deleteRankById = (rankID) => {
    const allRanks = [...this.state.ranks];
    const allRanksAfterDelete = allRanks.filter((r) => r.ID !== rankID);

    this.db
      .collection("ranks")
      .doc(rankID)
      .delete()
      .then((result) => {
        this.setState({ ranks: [...allRanksAfterDelete] });
      })
      .catch((err) => {
        // console.log("Rank deletion error: ", err);
      });
  };

  addNewMember = (e, newMember) => {
    // Add a new document with a generated id.
    this.db
      .collection("members")
      .add(newMember)
      .then((docRef) => {
        this.db
          .collection("members")
          .doc(docRef.id)
          .update({ ID: docRef.id })
          .then((result) => {
            // console.log("Added new member: ", docRef.id);

            // Send email to user and admin
            const headers = {
              "Content-Type": "application/json",
            };

            const AZURE_URL_WELCOME =
              "https://prod-28.northeurope.logic.azure.com:443/workflows/09a68f374e294a4aba0e2afbb62bc57f/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=M1UODZC8BdF5Ph5KvoImPajziTWW9OrBJl5w40ZF1cc";

            fetch(AZURE_URL_WELCOME, {
              method: "POST",
              mode: "cors",
              headers: headers,
              body: JSON.stringify(newMember),
            }).then((r) => {
              window.location.href = "/#/thanks";
              window.history.pushState(null, null, "/#/thanks");
              // window.location.reload();
              // window.history.go();
            });
          })
          .catch(function (error) {
            console.error("Error adding document: ", error);
          });
      })
      .catch(function (error) {
        console.error("Error adding document: ", error);
      });

    // save the new rank to the db
  };

  addNewMemberInternal = (e, newMember) => {
    // Add a new document with a generated id.

    console.log("new MEMBER TO BE ADDED: ", newMember);

    this.db
      .collection("members")
      .add(newMember)
      .then((docRef) => {
        this.db
          .collection("members")
          .doc(docRef.id)
          .update({ ID: docRef.id })
          .then((result) => {
            console.log("Added new member: ", docRef.id);
            window.history.back();
          })
          .catch(function (error) {
            console.error("Error adding document: ", error);
          });
      })
      .catch(function (error) {
        console.error("Error adding document: ", error);
      });

    // save the new rank to the db
  };

  newMember = () => {
    // Add a new document with a generated id.
    this.db
      .collection("members")
      .add(iMemberProfile)
      .then((docRef) => {
        console.log("new member placeholder added with ID: ", docRef.id);

        this.db
          .collection("members")
          .doc(docRef.id)
          .update({ ID: docRef.id, Started: Moment().toString() })
          .then((result) => {
            window.history.pushState(null, null, "/edit/member/" + docRef.id);
            window.location.reload();
            // window.history.go();
          })
          .catch(function (error) {
            console.error("Error adding document: ", error);
          });
      })
      .catch(function (error) {
        console.error("Error adding document: ", error);
      });

    // save the new rank to the db
  };

  userIs = (accessTypes) => {
    // try {
    // if (!this.state.currentlyLoggedInUser.uidProfile.accessType) {
    //   return false;
    // }

    // console.log("accessTypes ----", accessTypes && accessTypes);
    // console.log("accessTypes ----", this.state.currentlyLoggedInUser);

    const foundAccessType =
      accessTypes &&
      accessTypes.find(
        (at) =>
          this.state.currentlyLoggedInUser &&
          this.state.currentlyLoggedInUser.uidProfile &&
          this.state.currentlyLoggedInUser.uidProfile.accessType &&
          this.state.currentlyLoggedInUser.uidProfile.accessType[at] == true
      );

    // console.log("found ACCESS TYPE: ", foundAccessType);

    if (foundAccessType) {
      return true;
    } else {
      return false;
    }
    // } catch (err) {
    //   console.log("useraccesstypes ERror: ", err);
    // }
  };

  render() {
    const RouteToMembersDetailTable = (
      <Route
        path="/membersdetailtable/:teamId?/:status?/:searchValue?"
        exact
        render={(props) => {
          const members = this.userIs(["admin", "writer"]) ? (
            <Members
              mode="membersDetailTable"
              setPrintMode={(mode) => this.setPrintMode(mode)}
              isAuthenticated={this.state.isAuthenticated}
              firebaseReady={this.state.firebaseReady}
              loadMembers={() => this.loadMemberData()}
              membersLoaded={this.state.membersLoaded}
              filteredMembers={this.state.filteredMembers}
              ranks={this.state.ranks}
              searchValue={props.match.params.searchValue}
              teamId={props.match.params.teamId}
              teams={this.state.teams}
              status={props.match.params.status}
              updateFilteredMembers={(searchValue, teamId, status) =>
                this.updateFilteredMembers(searchValue, teamId, status)
              }
            />
          ) : (
            <Redirect to="/" />
          );
          return members;
        }}
      />
    );
    const RouteToMembersKeikenTable = (
      <Route
        path="/memberskeikentable/:teamId?/:status?/:searchValue?"
        exact
        render={(props) => {
          const members = this.userIs(["admin", "writer"]) ? (
            <Members
              mode="membersKeikenTable"
              setPrintMode={(mode) => this.setPrintMode(mode)}
              isAuthenticated={this.state.isAuthenticated}
              firebaseReady={this.state.firebaseReady}
              loadMembers={() => this.loadMemberData()}
              membersLoaded={this.state.membersLoaded}
              filteredMembers={this.state.filteredMembers}
              ranks={this.state.ranks}
              searchValue={props.match.params.searchValue}
              teamId={props.match.params.teamId}
              teams={this.state.teams}
              status={props.match.params.status}
              updateFilteredMembers={(searchValue, teamId, status) =>
                this.updateFilteredMembers(searchValue, teamId, status)
              }
            />
          ) : (
            <Redirect to="/" />
          );
          return members;
        }}
      />
    );
    const RouteToMembersCSVPage = (
      <Route
        path="/memberscsv/:teamId?/:status?/:searchValue?"
        exact
        render={(props) => {
          const members = this.userIs(["admin", "writer"]) ? (
            <Members
              mode="csv"
              setPrintMode={(mode) => this.setPrintMode(mode)}
              isAuthenticated={this.state.isAuthenticated}
              firebaseReady={this.state.firebaseReady}
              loadMembers={() => this.loadMemberData()}
              membersLoaded={this.state.membersLoaded}
              filteredMembers={this.state.filteredMembers}
              ranks={this.state.ranks}
              searchValue={props.match.params.searchValue}
              teamId={props.match.params.teamId}
              teams={this.state.teams}
              status={props.match.params.status}
              updateFilteredMembers={(searchValue, teamId, status) =>
                this.updateFilteredMembers(searchValue, teamId, status)
              }
            />
          ) : (
            <Redirect to="/" />
          );
          return members;
        }}
      />
    );
    const RouteToMembersTestSheetPage = (
      <Route
        path="/membersTestSheet/:teamId?/:status?/:searchValue?"
        exact
        render={(props) => {
          const members = this.userIs(["admin", "writer"]) ? (
            <Members
              mode="membersTestSheet"
              setPrintMode={(mode) => this.setPrintMode(mode)}
              isAuthenticated={this.state.isAuthenticated}
              firebaseReady={this.state.firebaseReady}
              loadMembers={() => this.loadMemberData()}
              membersLoaded={this.state.membersLoaded}
              filteredMembers={this.state.filteredMembers}
              ranks={this.state.ranks}
              searchValue={props.match.params.searchValue}
              teamId={props.match.params.teamId}
              teams={this.state.teams}
              status={props.match.params.status}
              updateFilteredMembers={(searchValue, teamId, status) =>
                this.updateFilteredMembers(searchValue, teamId, status)
              }
            />
          ) : (
            <Redirect to="/" />
          );
          return members;
        }}
      />
    );
    const RouteToMembersTestResultSheetPage = (
      <Route
        path="/membersTestResultSheet/:teamId?/:status?/:searchValue?"
        exact
        render={(props) => {
          const members = this.userIs(["admin", "writer"]) ? (
            <Members
              mode="membersTestResultSheet"
              setPrintMode={(mode) => this.setPrintMode(mode)}
              isAuthenticated={this.state.isAuthenticated}
              firebaseReady={this.state.firebaseReady}
              loadMembers={() => this.loadMemberData()}
              membersLoaded={this.state.membersLoaded}
              filteredMembers={this.state.filteredMembers}
              ranks={this.state.ranks}
              searchValue={props.match.params.searchValue}
              teamId={props.match.params.teamId}
              teams={this.state.teams}
              status={props.match.params.status}
              updateFilteredMembers={(searchValue, teamId, status) =>
                this.updateFilteredMembers(searchValue, teamId, status)
              }
            />
          ) : (
            <Redirect to="/" />
          );
          return members;
        }}
      />
    );
    const RouteToMembersPage = (
      <Route
        path="/members/:teamId?/:status?/:searchValue?"
        exact
        render={(props) => {
          const members = this.userIs(["admin", "writer", "member"]) ? (
            <Members
              mode="web"
              setPrintMode={(mode) => this.setPrintMode(mode)}
              deleteMember={this.deleteMember}
              foundNewMembersCount={this.state.foundNewMembersCount}
              isAuthenticated={this.state.isAuthenticated}
              currentlyLoggedInUser={this.state.currentlyLoggedInUser}
              firebaseReady={this.state.firebaseReady}
              loadMembers={() => this.loadMemberData()}
              membersLoaded={this.state.membersLoaded}
              filteredMembers={this.state.filteredMembers}
              ranks={this.state.ranks}
              searchValue={props.match.params.searchValue}
              teamId={props.match.params.teamId}
              status={props.match.params.status}
              updateFilteredMembers={(searchValue, teamId, status) =>
                this.updateFilteredMembers(searchValue, teamId, status)
              }
              newMember={() => this.newMember()}
            />
          ) : (
            <Redirect to="/" />
          );
          return members;
        }}
      />
    );

    const RouteToActivitiesPage = (
      <Route
        path="/activities/:teamId?/:status?/:searchValue?"
        exact
        render={(props) => {
          const activities = this.userIs(["admin", "writer"]) ? (
            <Activities
              foundNewMembersCount={this.state.foundNewMembersCount}
              isAuthenticated={this.state.isAuthenticated}
              currentlyLoggedInUser={this.state.currentlyLoggedInUser}
              firebaseReady={this.state.firebaseReady}
              loadMembers={() => this.loadMemberData()}
              activityTypes={this.state.activityTypes}
              membersLoaded={this.state.membersLoaded}
              filteredMembers={this.state.filteredMembers}
              ranks={this.state.ranks}
              searchValue={props.match.params.searchValue}
              teamId={props.match.params.teamId}
              status={props.match.params.status}
              updateMember={this.updateMember}
              updateFilteredMembers={(searchValue, teamId, status) =>
                this.updateFilteredMembers(searchValue, teamId, status)
              }
            />
          ) : (
            <Redirect to="/" />
          );
          return activities;
        }}
      />
    );

    const RouteToNewMemberPage = (
      <Route
        path="(/newmember|/tilmelding)"
        exact
        render={(props) => (
          <NewMember
            currentlyLoggedInUser={this.state.currentlyLoggedInUser}
            firebaseReady={this.state.firebaseReady}
            loadTeams={() => this.loadTeamsData()}
            addNewMember={(e, newMember) => this.addNewMember(e, newMember)}
            membersLoaded={this.state.membersLoaded}
            teams={this.state.teams}
          />
        )}
      />
    );

    // This si for the logged in user
    const RouteToNewUserPage = (
      <Route
        path="/newuser"
        exact
        render={(props) => (
          <NewUser
            currentlyLoggedInUser={this.state.currentlyLoggedInUser}
            firebaseReady={this.state.firebaseReady}
          />
        )}
      />
    );

    const RouteToTakPage = (
      <Route path="/thanks" exact render={(props) => <Tak />} />
    );

    const RouteToStatPage = (
      <Route
        path="/stat"
        exact
        render={(props) => (
          <Stat
            currentlyLoggedInUser={this.state.currentlyLoggedInUser}
            firebaseReady={this.state.firebaseReady}
            loadMembers={() => this.loadMemberData()}
            membersLoaded={this.state.membersLoaded}
            members={this.state.members}
            ranks={this.state.ranks}
          />
        )}
      />
    );

    const RouteToRankingPage = (
      <Route
        path="/ranking/:teamId?/:status?/:searchValue?"
        exact
        render={(props) =>
          this.userIs(["admin", "writer"]) ? (
            <Ranking
              currentlyLoggedInUser={this.state.currentlyLoggedInUser}
              isAuthenticated={this.state.isAuthenticated}
              firebaseReady={this.state.firebaseReady}
              loadMembers={() => this.loadMemberData()}
              membersLoaded={this.state.membersLoaded}
              searchValue={props.match.params.searchValue}
              filteredMembers={this.state.filteredMembers}
              ranks={this.state.ranks}
              teamId={props.match.params.teamId}
              status={props.match.params.status}
              levels={this.state.levels}
              addRankToSelectedMembers={this.addRankToSelectedMembers}
              updateFilteredMembers={(searchValue, teamId, status) =>
                this.updateFilteredMembers(searchValue, teamId, status)
              }
            />
          ) : (
            <Redirect to="/" />
          )
        }
      />
    );

    const RouteToMemberProfilePage = (
      <Route
        path="/member/:id"
        exact
        render={(props) => {
          const memberProfile = this.userIs(["admin", "writer"]) ? (
            <MemberProfile
              isAuthenticated={this.state.isAuthenticated}
              firebaseReady={this.state.firebaseReady}
              loadMembers={() => this.loadMemberData()}
              membersLoaded={this.state.membersLoaded}
              member={this.state.members.find(
                (m) => m.ID == props.match.params.id
              )}
              memberRanks={this.state.ranks.filter(
                (r) => r.MemberId == props.match.params.id
              )}
              teams={this.state.teams}
            />
          ) : (
            <Redirect to="/" />
          );
          return memberProfile;
        }}
      />
    );

    const RouteToMemberProfileEditPage = (
      <Route
        path="/edit/member/:id"
        exact
        render={(props) => {
          console.log(
            "***************************ROUTER TO MemberProfileEdit*************************"
          );
          console.log(
            "* this.state.currentlyLoggedInUser-------------:",
            this.state.currentlyLoggedInUser
          );
          console.log(
            "* this.userIs()-------------:",
            this.userIs(["admin", "writer"])
          );
          console.log(
            "* props.match.params.id-------------:",
            props.match.params.id
          );
          console.log("* this.state.members------------:", this.state.members);

          return this.userIs(["admin", "writer"]) ? (
            <MemberProfileEdit
              isAuthenticated={this.state.isAuthenticated}
              currentlyLoggedInUser={this.state.currentlyLoggedInUser}
              firebaseReady={this.state.firebaseReady}
              loadMembers={() => this.loadMemberData()}
              membersLoaded={this.state.membersLoaded}
              updateMember={this.updateMember}
              addNewMemberInternal={(e, newMember) =>
                this.addNewMemberInternal(e, newMember)
              }
              paramsMemberId={props.match.params.id}
              memberRanks={this.state.ranks.filter(
                (r) => r.MemberId == props.match.params.id
              )}
              teams={this.state.teams}
              deleteRankById={this.deleteRankById}
              member={
                props.match.params.id == "new"
                  ? { ...iMemberProfile }
                  : this.state.members.find(
                      (m) => m.ID == props.match.params.id
                    )
              }
            />
          ) : (
            <Redirect to="/" />
          );
        }}
      />
    );
    const login = (
      <React.Fragment>
        <Route
          path="/login"
          exact
          render={(props) => {
            if (this.state.isAuthenticated) {
              return <Redirect to="/members/0/any" />;
            } else {
              return (
                <Login
                  db={this.db}
                  currentUser={
                    this.state.authenticatedUser && this.state.authenticatedUser
                  }
                  setAuthenticatedUser={(user) =>
                    this.setAuthenticatedUser(user)
                  }
                />
              );
            }
          }}
        />
      </React.Fragment>
    );

    // console.log("props.location -> ", this.props)
    // console.log("props.location -> ", this.state);
    return this.state.firebaseReady ? (
      <Router>
        <AppWrap printMode={this.state.printMode}>
          {RouteToActivitiesPage}
          {RouteToMembersCSVPage}
          {RouteToMembersDetailTable}
          {RouteToMembersKeikenTable}
          {RouteToMembersTestSheetPage}
          {RouteToMembersTestResultSheetPage}
          {RouteToStatPage}

          {RouteToRankingPage}

          {RouteToMembersPage}
          {RouteToMemberProfileEditPage}
          {RouteToMemberProfilePage}

          {RouteToNewMemberPage}
          {RouteToTakPage}
          {RouteToNewUserPage}

          {login}
          <Route
            path="/logout"
            exact
            render={(props) => {
              firebase
                .auth()
                .signOut()
                .then((r) => {
                  console.log("sign off success!");
                  console.log(this.props);
                  window.history.pushState(null, null, "/");
                  window.location.reload();
                });
              return <div>Logger af...</div>;
            }}
          />

          <Route
            path="/"
            exact
            render={(props) => {
              console.log("CHECKE USER AUTHENTICATION");
              if (this.state.isAuthenticated) {
                console.log("USER IS AUTHENTICATED");
                if (this.userIs(["member"])) {
                  return <Redirect to="/members/-1/any" />;
                } else if (this.userIs(["admin", "writer"])) {
                  return <Redirect to="/activities/-100/any" />;
                } else {
                  return <Redirect to="/newuser" />;
                }
              } else {
                console.log("USER IS NOT AUTHENTICATED");
                return <Redirect to="/login" />;
              }
            }}
          />
        </AppWrap>
      </Router>
    ) : this.state.firebaseNotInitialized ? (
      <div>
        Beklager...din browser understøttes ikke. Brug Chrome eller Firefox.
        <p>
          Hvis det ikke er muligt så klik her og tilmeld dig via email{" "}
          <a href="mailto:skovbokarate@gmail.com">skovbokarate@gmail.com</a>
        </p>
      </div>
    ) : null;
  }
}

export default App;
